<template>
  <div class="content-wrap">
    <template class>
      <headers style="width:100%;"></headers>
      <el-container style="display: flex;flex-direction: column">
        <el-header style="overflow: hidden;height:40px">
          <home-menu v-if="!homeMenuFlag"></home-menu>
          <div v-else>
            <detail-breadcrumb :type="type"></detail-breadcrumb>
          </div>
        </el-header>
        <el-main>
          <div class="app-main">
            <div class="app-aside" v-if="navFlag && showMenus">
              <nav-sides :is-collapse="isCollapse"></nav-sides>
            </div>
            <div class="app-content">
              <!--                <transition :name="transitionName">-->
              <!-- 子服务不会在主服务中同时存在component，router-view与容器可以并存 -->
              <router-view></router-view>
              <!-- qiankun: 子应用容器 -->
              <div id="subapp-container"></div>
              <!--                </transition>-->
            </div>
          </div>
        </el-main>
      </el-container>
      <perfect :showPerfect="showFlag"></perfect>
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import NavSides from '@/components/Aside/index.vue';
import Headers from '@/components/Header/index.vue';
import HomeMenu from './components/HomeMenu';
import DetailBreadcrumb from './components/DetailBreadcrumb';
import perfect from '@/components/perfect.vue';
import { getStorage } from '@/tools/storage';

export default {
  name: 'App',
  data() {
    return {
      isCollapse: false,
      iconCollapse: 'el-icon-arrow-left',
      showFlag: true,
      navFlag: false,
      homeMenuFlag: false, //true显示面包屑，false显示上面菜单
      type: '',
      transitionName: ''
    };
  },
  components: {
    NavSides,
    Headers,
    HomeMenu,
    DetailBreadcrumb,
    perfect
  },
  computed: {
    ...mapState({
      projectId: state => state.homeProject.id,
      showMenus: state => state.showMenus
    })
  },
  methods: {
    ...mapMutations(['ISCOLLAPSE']),
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
      this.isCollapse
        ? (this.iconCollapse = 'el-icon-arrow-right')
        : (this.iconCollapse = 'el-icon-arrow-left');
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.navFlag = !!to.meta.hasAside;
        this.homeMenuFlag =
          ['projectAsideList', 'orderAsideList'].includes(to.meta.asideName) ||
          to.meta.hasBread;
        this.type = this.homeMenuFlag ? to.meta.asideName : '';
        // const toDepth = to.path.split('/').length;
        // const fromDepth = from.path.split('/').length;
        this.transitionName = this.transitionName = 'slide-left';
      }
    },
    isCollapse: {
      immediate: true,
      handler() {}
    }
  },
  mounted() {
    // start(); // 注意调用时机，容器 DOM 加载完成： https://qiankun.umijs.org/zh/faq#application-died-in-status-not_mounted-target-container-with-container-not-existed-while-xxx-loading
  },
  created() {
    let otherInfo = getStorage('otherInfo');
    if (!otherInfo.invoiceBankNo || !otherInfo.invoiceOpenBank) {
      this.showFlag = true;
    } else {
      this.showFlag = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-header,
.el-footer {
  background: #ffffff;
  height: 55px;
  display: flex;
  align-items: center;
  padding-left: 40px;
}

.el-aside {
  background-color: rgba(255, 255, 255, 1);
  color: #333;
  text-align: center;
  /* line-height: 200px; */
}

.el-aside * {
  font-size: 16px;
}

.el-main {
  background-color: rgba(247, 251, 255, 1);
  color: #333;
  text-align: center;
  /* line-height: 160px; */
  padding-bottom: 0;
  position: relative;
  /* padding: 1.56vw; */
}

body > .el-container {
  margin-bottom: 40px;
}
</style>

<style lang="scss">
@import '~@/styles/theme.scss';
.el-container {
  background: #ececec;
}

.content-wrap {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* 全局style */
.header-box {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.collapse {
  transform: translateX(-100%);
  // margin-right: 20px;
}
.page-toggle-enter-active {
  position: absolute !important;
  animation-duration: 0.8s !important;
  width: calc(100%) !important;
}

.page-toggle-leave-active {
  position: absolute !important;
  animation-duration: 0.8s !important;
  width: calc(100%) !important;
}

.aside-left {
  float: left;
  border-right: 1px solid #e6e6e6;
}

.el-main {
  //padding: 10px;
  margin-top: 3px;
  position: relative;
}

.app-main {
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
}

.app-aside {
  width: 200px;
  //position: absolute;
  left: 0;
  float: left;
  text-align: left !important;
  border-right: 1px solid #e6e6e6;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    width: 6px;
    background: #e2e2e2;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #8d9096;
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #686868;
    cursor: pointer;
  }
}

.app-content {
  // overflow-x: hidden;
  overflow-y: auto;
  padding: 8px 16px;
  text-align: left;
  background: #f7fbff;
  height: 100%;
  position: relative;
  //left: 200px;
}
.app-label {
  color: $--color-sub;
}
.app-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pointer {
  cursor: pointer;
}

.no-select {
  user-select: none;
}

//.slide-right-enter-active {
//  transition: all 0.2s ease-in-out;
//}
//
//.slide-right-enter {
//  transform: translateX(100%);
//}说
//
//.slide-right-enter-to {
//  transform: translateX(0);
//}

.slide-left-enter-active {
  transition: all 0.1s;
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(20px);
}

.slide-left-enter-to {
  opacity: 1;
  transform: translateX(0);
}
</style>
